import { TextLink } from "@/components/links/TextLink";
import { SoftText } from "@/components/text/SoftText";

export function PrivacyNotice() {
  return (
    <div>
      <SoftText elementType="p">
        By continuing, you agree to our{" "}
        <TextLink external={false} href="/privacy" className="text-primary">
          Privacy Policy
        </TextLink>{" "}
        and{" "}
        <TextLink external={false} href="/terms" className="text-primary">
          Terms of Service
        </TextLink>
        .
      </SoftText>
      <SoftText elementType="p" className="mt-2">
        This site is protected by reCAPTCHA and Google's{" "}
        <TextLink
          external={false}
          href="https://policies.google.com/privacy"
          className="text-primary"
        >
          Privacy Policy
        </TextLink>{" "}
        and{" "}
        <TextLink
          external={false}
          href="https://policies.google.com/terms"
          className="text-primary"
        >
          Terms of Service
        </TextLink>{" "}
        apply.
      </SoftText>
    </div>
  );
}
